import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { Subtitle } from "components/Dashboard/components/Subtitle";

import LimitContainer from "./LimitContainer";

const ResourceLimits = () => {
    const { gray200 } = colors;

    const { t } = useTranslation();

    return (
        <div
            css={css({
                borderTop: `1px solid ${gray200}`,
                paddingTop: "23px",
                marginTop: "24px"
            })}
        >
            <Subtitle text={t("Dashboard##title##resource limits")} />
            <LimitContainer />
        </div>
    );
};

export default ResourceLimits;
